<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h2 class="text-success"><span class="ti-check-box"></span> You will receive the link to reset your password</h2>
              <h3 class="">We will send you the link to reset your password if the email address you typed exists in our system</h3>
              <p class="text-muted mt-4">You can close this page</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
